'use strict';

// EXPORTS //

module.exports = require( './dataset.json' );
